import { OPAOrderTypes } from './PatientDashboard/Patient.model'
import { IAnnouncementAction } from '../../types/IAnnouncement'

export const OPEN_SCREENING_FORMS_LABEL = 'Open screening forms'

/** The BFF's refusal reason when consent is captured but Castor screening is not complete. */
export const PTA_SCREENING_INCOMPLETE_REASON = 'PtaScreeningIncomplete'

/**
 * CLOS-14590: the refusal link for a PTA order start. The order checks re-read Castor
 * live, so Begin or Continue order can be refused after screening was confirmed; the BFF
 * says so in the refusal's reason, and the refusal then links straight to the patient's
 * screening forms. A resupply is never refused for screening (a shipped order is enough
 * and Castor is not checked), so it never gets the link.
 */
export const screeningFormsRefusalAction =
  (openScreeningForms: () => void, orderType?: string) =>
  (reason?: string): IAnnouncementAction | undefined =>
    reason === PTA_SCREENING_INCOMPLETE_REASON &&
    orderType !== OPAOrderTypes.Resupply
      ? { label: OPEN_SCREENING_FORMS_LABEL, onClick: openScreeningForms }
      : undefined
